import { ProviderActivePtinStatusDto } from 'iam/models/ProviderActivePtinStatusDto'
import { Id } from 'types/definitions'

export interface ProviderMembershipDTO {
  workspace_id: string
  job_capacity: number
}

export enum ProviderStatusDTO {
  Active = 'ACTIVE',
  Decommissioned = 'DECOMMISSIONED',
  Suspended = 'SUSPENDED',
  OnLeave = 'ON_LEAVE',
  Null = 'NULL',
}

export enum ProviderTypeDTO {
  CPA = 'CPA',
  EA = 'EA',
  NotApplicable = 'NOT_APPLICABLE',
}

export interface ProviderDTO {
  user_public_id: Id
  given_name: string
  family_name: string
  email: string
  phone: string
  picture: string
  workspaces: ProviderMembershipDTO[]
  global_job_capacity: number
  software_experience: string[]
  software_owned: string[]
  supplemental_software_experience: string[]
  years_experience: number
  state_region: string
  active_ptin: ProviderActivePtinStatusDto
  provider_status: ProviderStatusDTO
  specialties: string[]
  date_created: string
  date_modified: string
  pro_manager: string
  pro_type: ProviderTypeDTO
}

export interface UpdateProviderUserDataPayload {
  software_owned: string[]
  software_experience: string[]
  supplemental_software_experience: string[]
  pro_specialties: string[]
  state_region: string
  years_experience: number
}
